import React, { useState, useEffect } from "react";
import { IoIosClose } from "react-icons/io";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import { FaRegTrashAlt } from "react-icons/fa";
import CollectOrderService from "../../../services/CollectOrderService";
import MinorCollectOrderDetails from './../../molecules/MinorCollectOrderDetails';


export default function InitiateScreeningModal({
    isModalOpen,
    setModalOpen,
    collectOrderId,
}) {
  const {
    register,
    handleSubmit,
    reset,
    getValues,
    formState: { errors },
  } = useForm();

  const [collectOrderObject, setCollectOrderObject] = useState();
  const [ updated, setUpdated ] = useState()

  const [codItemsColetados, setCodItemsColetados] = useState([]); // Estado inicial vazio


  useEffect(() => {
    async function fetchRequest() {
      const cOrder = await CollectOrderService.getCollectOrdersById(
        collectOrderId
      );
      setCollectOrderObject(cOrder);
    }

    fetchRequest();

  }, [collectOrderId, isModalOpen, updated]);


  // useEffect para atualizar 'codItemsColetados' assim que 'collectOrderObject' for carregado
  useEffect(() => {
    if (collectOrderObject?.collectOrder?.codItemsColetados) {
      setCodItemsColetados(collectOrderObject.collectOrder.codItemsColetados);
    }
  }, [collectOrderObject]); // Executa sempre que 'collectOrderObject' for atualizado

  const onSubmit = async (data) => {

    if(collectOrderObject?.collectOrder?.codItemsColetados?.length !== collectOrderObject?.collectOrder?.qtdColeta){
      toast.error("Quantidade de itens insuficiente");
      return;
    }

    data = { ...data, status: "FINALIZADA" };

    try {
      await CollectOrderService.updateParcial(collectOrderId, data);
      toast.success("Coleta Finalizada!");
    } catch (error) {
      toast.error(error.message);
    }

    setModalOpen(!isModalOpen);
    reset();
  };

  const onClose = () => {
    setModalOpen(!isModalOpen);
    reset();
  };

  const handleAddItem = async () => {
    const codEquipamentoValue = getValues("codEquipamentoColetado");
    const serialNumberValue = getValues("serialNumber"); // Capture o valor do serialNumber
  
    const item = {
      codigo: codEquipamentoValue,
      serialNumber: serialNumberValue, // Inclua o serialNumber
      aceito: true // Valor padrão, como solicitado
    };
  
    try {
      await CollectOrderService.addItemToCollectOrder(collectOrderId, item);
      toast.success("Item adicionado!");
      setUpdated(!updated);
      reset();
    } catch (error) {
      toast.error(error.message);
    }
  };
  

  const handleRemoveItem = async (cod) => {

    const response = await CollectOrderService.removeItemFromCollectOrder(collectOrderId, cod);
    if (response) {
        // Item removido com sucesso, faça o que for necessário
        toast.success("Item removido!");
        setUpdated(!updated)
    } else {
        // Trate o erro, se necessário
        toast.error("Ops! Algo deu errado");
    }
  }

  const handleChangeAceito = async (codigo, serialNumber, aceito) => {
    const data = { codigo, serialNumber, aceito }; // Envia também o serialNumber
  
    try {
      await CollectOrderService.updateAceito(collectOrderId, data);
      toast.success("Status do item atualizado!");
  
      // Atualiza o estado local após a mudança
      setCodItemsColetados(prevItems =>
        prevItems.map(item => 
          item.codigo === codigo && item.serialNumber === serialNumber ? { ...item, aceito } : item
        )
      );
    } catch (error) {
      toast.error(error.message);
    }
  };
  
  

  if (isModalOpen) {
    return (
      <div
        className="flex flex-col relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto"
          onClick={onClose}
        >
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="flex flex-col w-[648px] h-fit pb-4 relative transform rounded-lg bg-white text-left shadow-xl transition-all mt-6" onClick={(e) => e.stopPropagation()}>
            <button
                onClick={onClose}
                className="absolute -top-7 -right-7 rounded-full p-1"
              >
                <div className="w-12 h-12 flex bg-gray-200 justify-center items-center rounded-full ms-6">
                  <div className="flex justify-center items-center">
                    <IoIosClose color={"black"} size={32} />
                  </div>
                </div>
              </button>
              <div className="flex flex-col px-4 text-left gap-2 bg-gray-800 rounded-t-lg">
                <div className="text-white text-xl font-bold mt-4">
                  TRIAGEM
                </div>
                <div className="flex justify-between">
                  <div className="text-white text-sm px-4">
                    Coleta:{" "}
                    {collectOrderObject?.collectOrder.idCollectOrder}
                  </div>
                  <div className="text-white text-sm px-4">
                    Ref Solicitação:{" "}
                    {collectOrderObject?.collectOrder.idRequest}
                  </div>
                </div>
              </div>

              <MinorCollectOrderDetails collectOrder={collectOrderObject?.collectOrder} />

              {/* MODAL FORM BEGIN */}

              <div className="flex flex-col mt-6 px-6">
                <div className="w-full relative inline-block text-left">
                  <div className="w-full flex flex-col text-sm">

                    
                    <div className="flex flex-col items-start gap-1 mb-4 w-full">
                      
                      <div className="w-full flex gap-2">
                        {/* Input para o Código */}
                        <div className="w-full flex flex-col">
                          <label className="block text-gray-700 font-bold whitespace-nowrap">
                            Cód Equipamento:
                          </label>
                          <input
                            type="text"
                            {...register("codEquipamentoColetado")}
                            className={`block w-full rounded-lg px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                            ${errors?.codEquipamentoColetado?.type === "required"
                                ? " border border-red-500 outline-none ring-0"
                                : "border border-zinc-500 outline-none ring-0"
                              }
                          `}
                          />
                        </div>

                        {/* Input para o Serial Number */}
                        <div className="w-full  flex flex-col">
                        <label className="block text-gray-700 font-bold whitespace-nowrap">
                          Serial Number:
                        </label>
                        <input
                          type="text"
                          {...register("serialNumber")}
                          className={`block w-full rounded-lg px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                            ${errors?.serialNumber?.type === "required"
                              ? " border border-red-500 outline-none ring-0"
                              : "border border-zinc-500 outline-none ring-0"
                            }
                          `}
                        />
                        </div>

                        <button
                          onClick={handleAddItem}
                          className="bg-blue-500 text-white py-1 px-4 rounded-2xl hover:bg-blue-600"
                        >
                          Inserir
                        </button>
                      </div>

                      {/* Mensagens de erro, se necessário */}
                      {errors?.codEquipamentoColetado?.type === "required" && (
                        <p className="text-red-500 text-xs ms-2">Código é obrigatório</p>
                      )}
                      {errors?.serialNumber?.type === "required" && (
                        <p className="text-red-500 text-xs ms-2">Serial Number é obrigatório</p>
                      )}


                      {/* DIV movimentações */}
                      {collectOrderObject?.collectOrder?.codItemsColetados?.length !== 0 && (
                        <div className="flex flex-col w-full max-h-60 overflow-y-auto border border-zinc-500 rounded-lg">
                          <table className="min-w-full bg-white text-xs">
                            <thead>
                              <tr className="bg-gray-200 text-black border-b">
                                <th className="px-6 py-1 rounded-tl-lg">
                                  <div className="flex items-center justify-center">#</div>
                                </th>
                                <th className="px-6 py-1">
                                  <div className="flex items-center justify-center">Código</div>
                                </th>
                                <th className="px-6 py-1">
                                  <div className="flex items-center justify-center">Serial Number</div> {/* Nova coluna "Serial Number" */}
                                </th>
                                <th className="px-6 py-1">
                                  <div className="flex items-center justify-center">Aceito</div> {/* Coluna "Aceito" */}
                                </th>
                                <th className="px-6 py-1 rounded-tr-lg">
                                  <div className="flex items-center justify-center">Ação</div>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {codItemsColetados.map((item, index) => (
                                <tr key={index}>
                                  <td className="w-10 px-6 py-2 whitespace-nowrap border-b">
                                    <div className="flex items-center justify-center">{index + 1}</div>
                                  </td>
                                  <td className="px-6 py-2 whitespace-nowrap border-b">
                                    <div className="flex items-center justify-center">{item.codigo}</div>
                                  </td>
                                  <td className="px-6 py-2 whitespace-nowrap border-b"> {/* Nova coluna "Serial Number" */}
                                    <div className="flex items-center justify-center">{item.serialNumber}</div>
                                  </td>
                                  <td className="px-6 py-2 whitespace-nowrap border-b">
                                    <div className="flex items-center justify-center">
                                      <input
                                        type="checkbox"
                                        checked={item.aceito}
                                        onChange={(e) => handleChangeAceito(item.codigo, item.serialNumber, e.target.checked)} // Envie também o serialNumber
                                      />
                                    </div>
                                  </td>
                                  <td className="w-10 px-6 py-2 whitespace-nowrap border-b">
                                    <div className="flex items-center justify-center">
                                      <button onClick={() => { handleRemoveItem(item.codigo, item.serialNumber) }}> {/* Adiciona serialNumber */}
                                        <FaRegTrashAlt color="red" size={14} />
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}

                      <div>Quantidade lida: {collectOrderObject?.collectOrder?.codItemsColetados.length}</div>
                    </div>


                    <div className="flex flex-col items-start gap-1 mb-4 w-full">
                      <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                        Observação da Triagem:
                      </label>
                      <textarea
                        {...register("observacao", {
                          // required: true,
                        })}
                        className={`
                              w-full h-[100px] p-4 bg-white rounded-lg justify-start items-center inline-flex resize-none 
                              text-neutral-600 text-sm font-normal font-['Work Sans']
                              focus:border focus:border-zinc-800 focus:outline-none focus:ring-0
                              placeholder:text-neutral-400 placeholder:text-sm placeholder:font-normal placeholder:font-['Work Sans'] placeholder:leading-[14.34px]
                              ${
                                errors?.obsTriagem?.type ===
                                "required"
                                  ? "border border-red-500 outline-none ring-0"
                                  : "border border-zinc-500 outline-none ring-0"
                              }
                          `}
                        placeholder={"Observação da triagem"}
                      ></textarea>
                      {errors?.obsTriagem?.type === "required" && (
                        <p className="text-red-500 text-xs whitespace-nowrap">
                          Campo obrigatório
                        </p>
                      )}
                    </div>

                    <button
                      onClick={() => handleSubmit(onSubmit)()}
                      className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
                    >
                      Enviar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
